import React from 'react';
import { Alert, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function EmailVerificationBanner() {
  return (
    <Box
      sx={{
        position: { xs: 'static', md: 'sticky' },
        top: { md: 0 },
        zIndex: { md: 1200 },
        mt: {
          xs: 'calc(var(--template-frame-height, 0px) + 64px)',
          md: 'var(--template-frame-height, 0px)',
        },
        ml: { md: '240px' },
      }}
    >
      <Alert severity="warning" sx={{ borderRadius: 0 }}>
        Please verify your email to unlock all features. Visit{' '}
        <RouterLink to="/settings">Settings</RouterLink>{' '}to resend the
        verification email.
      </Alert>
    </Box>
  );
}
